import { render } from "./NavigationSubMenu.vue?vue&type=template&id=40324c9c&scoped=true"
import script from "./NavigationSubMenu.vue?vue&type=script&lang=js"
export * from "./NavigationSubMenu.vue?vue&type=script&lang=js"

import "./NavigationSubMenu.vue?vue&type=style&index=0&id=40324c9c&scoped=scoped&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40324c9c"]])

export default __exports__